import { memo, useCallback, useMemo, useState } from "react";
import { useFormikContext } from "formik";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { ReactSVG } from "react-svg";
import { svgShapes } from "../../lib/svgShapes";
import { useSettings } from "../../providers/SettingsProvider";

function Shape({ name = "shape", shapeData = [], label, svg = {} }) {
    const { setFieldValue, values } = useFormikContext();
    const [shapeLimit, setShapeLimit] = useState(8);
    const { settings } = useSettings();
    const stroke = settings?.ifm_NaturalPrimaryColor;
    const selected = values[name] || [];

    const handleSelectShape = useCallback(
        (value) => {
            const next = selected.includes(value)
                ? selected.filter((item) => item !== value)
                : [...selected, value];
            setFieldValue(name, next);
        },
        [selected, setFieldValue, name]
    );

    const visible = useMemo(() => shapeData.slice(0, shapeLimit), [shapeData, shapeLimit]);

    return (
        <div className="flex flex-wrap mb-4 md:mb-8">
            <div className="w-full md:w-1/6 mt-3 mb-2 md:mb-1">
                <span className="para-label-box">{label}</span>
            </div>
            <div className="w-full md:w-5/6 md:p-0">
                <div className="shape-container">
                    {visible.map((shape) => {
                        const isSelected = selected.includes(shape);
                        return (
                            <label key={shape} className="shape-box-wrapper">
                                <input
                                    type="checkbox"
                                    value={shape}
                                    checked={isSelected}
                                    onChange={() => handleSelectShape(shape)}
                                    className="shape-checkbox"
                                />
                                <span
                                    className={`shape-box ${isSelected ? "selected" : "unselected"}`}
                                    data-tooltip={shape.toUpperCase()}
                                    title={shape.toUpperCase()}
                                >
                                    <ReactSVG
                                        className="shape-icon"
                                        src={svg[shape] || svgShapes.loader}
                                        style={{ fill: "none", stroke }}
                                        fallback={() => (
                                            <ReactSVG
                                                src={svgShapes.loader}
                                                className="pointer-events-none w-full h-full p-2"
                                                style={{ fill: "none", stroke }}
                                            />
                                        )}
                                        loading={() => (
                                            <ReactSVG
                                                src={svgShapes.loader}
                                                className="pointer-events-none w-full h-full p-2"
                                                style={{ fill: "none", stroke }}
                                            />
                                        )}
                                    />
                                </span>
                            </label>
                        );
                    })}
                    {shapeData.length > 10 &&
                        (shapeLimit === shapeData.length ? (
                            <CiCircleMinus
                                className="text-4xl mt-1 cursor-pointer text-wahchan-primary"
                                onClick={() => setShapeLimit(8)}
                            />
                        ) : (
                            <CiCirclePlus
                                className="text-4xl mt-1 cursor-pointer text-wahchan-primary-light"
                                onClick={() => setShapeLimit(shapeData.length)}
                            />
                        ))}
                </div>
            </div>
        </div>
    );
}

export default memo(Shape);
